module.exports = __webpack_public_path__ + "static/media/EDUOption.cedb5907.png";